import { FC, useRef } from 'react'
import clsx from 'classnames'
import ArrowDownIcon from '@/public/arrow-down.svg'
import { IInfoCard } from '@/interfaces/common'
import style from './accordion.module.scss'

interface AccordionItemProps extends IInfoCard {
  onClick: () => void
  isOpen: boolean
  isMoreShown: boolean
}

export const AccordionItem: FC<AccordionItemProps> = (props: AccordionItemProps) => {
  const { title, description, onClick, isOpen, isMoreShown } = props
  const itemRef = useRef<any>(null)

  return (
    <li className={clsx(style.accordionItem, { [style.active]: isOpen, [style.more]: isMoreShown })}>
      <button
        className={clsx(
          style.accordionButton,
          { [style.active]: isOpen },
          'text text_type_t1',
          isOpen ? 'text_color_main-blue' : 'text_color_dark'
        )}
        onClick={onClick}
      >
        <span>{title}</span>
        <ArrowDownIcon className={clsx(style.accordionArrow, { [style.active]: isOpen })} />
      </button>
      <div
        className={style.accordionCollapse}
        style={isOpen ? { height: itemRef.current.scrollHeight } : { height: '0px' }}
      >
        <div
          ref={itemRef}
          className={clsx('text text_type_t2 text_color_dark-070', style.accordionBody)}
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </div>
    </li>
  )
}
